import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiVarietyFinderAcceptTerms(): Promise<{accepted: boolean}> {
    return getFetch(`${API_SERVERLESS}/publicSearch/v3/varietyFinder/acceptTerms`, true);
}
